var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-view-wrapper"},[_c('tree-view-item',{staticClass:"tree-view-item-root",attrs:{"data":_vm.parsedData,"max-depth":_vm.allOptions.maxDepth,"modifiable":_vm.allOptions.modifiable,"current-depth":_vm.allOptions.maxDepth},on:{"change-data":_vm.onChangeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }